<template>
  <div class="usrBox">
    <van-cell-group>
      <div class="header">
        <van-row class="info">
          <van-col span='4' offset='1'>
            <van-image v-if ="$store.state.accessToken && $store.state.accessToken.headImgUrl" round width="55px" height="55px" :src="$store.state.accessToken.headImgUrl"/>
            <van-image v-else round width="55px" height="55px" :src="require('../../../assets/user.png')"/>
          </van-col>
          <van-col span='10' offset='2' style="margin-top:15px">{{ topUsername }}</van-col>
          <van-col span='6' offset='1' style="padding-top:30px;font-size:12px">预存账户<br>
            <span v-if="showBalancePreAmt" >￥{{ balancePre ? balancePre : '0' }}</span>
            <van-icon v-else name="closed-eye" class="toggle-password-icon" style="padding-left: 10px;" @click="infoAccount" />
          </van-col>
        </van-row>
        <van-divider content-position="left" style="color: aliceblue;">分润</van-divider>
        <van-row class="item">
          <van-col span='10'>待提现<br>
            <span v-if="showProfitAmt" style="font-size:14px">￥{{ balance ? balance : '0' }}</span>
            <van-icon v-else name="closed-eye" class="toggle-password-icon"  @click="profitState" />
          </van-col>
          <van-col span='6'>提现中<br>
            <span style="font-size:14px">{{ showProfitAmt?(underReview ? '￥'+underReview : '0'):'***' }}</span>
          </van-col>
         <van-col span='8'>已提现<br>
            <span style="font-size:14px">{{ showProfitAmt?(withdrawn ? '￥'+withdrawn : '0'):'***' }}</span>
          </van-col>
        </van-row>
      </div>
      <van-cell is-link center to="AgentAccount" title="提现记录" />
      <van-cell is-link center to="AccountSetup" title="账户设置" />
      <van-cell is-link center to="ChangePassword" title="密码修改" />
      <van-cell v-if="accountList.length >= 2" is-link center to="SwitchAccount" title="切换账号" />
      <van-cell @click="logout()" icon="warning-o" title="退出登录" is-link />
    </van-cell-group>
    <van-dialog v-model="binDingShow" title="请先验证手机号" :showConfirmButton= false closeOnClickOverlay @close="closeDiaLog">
      <van-notice-bar class="phoneTitle" :scrollable="false" left-icon="info-o" :text="phoneTitles" />
      <van-form @submit="onSubmit" ref='hbRef'>
        <van-field v-model="sms" center clearable label="短信验证码" placeholder="请输入验证码" >
          <template #button>
            <van-button native-type="button" :disabled="yzmTime" size="small" type="primary" @click="getChangeWx">
              <span v-show="!yzmTime">发送验证码</span>
              <van-count-down ref="countDown" v-show="yzmTime" time=60000 format="ss s" @finish="changeDownCount" />
            </van-button>
          </template>
        </van-field>
        <div class="btns">
          <van-button round block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>
    </van-dialog>
  </div>
</template>

<script>
import { Dialog } from 'vant'
import { infoAccount, profitState, unBindWeChat, signOut, getPhoneNumber, smsSend, myInfo } from '@/api/user.js'
export default {
  name: 'allUser',
  components: {},
  props: {},
  data () {
    return {
      showProfitAmt: false,
      binDingShow: false,
      // 验证码
      sms: '',
      // 手机号
      phoneNum: '',
      // 预存余额
      balancePre: '',
      showBalancePreAmt: false,
      // 分润
      balance: '',
      underReview: '',
      withdrawn: '',
      // 卡的数量
      quantity: '',
      // 当前等级
      rank: '',
      // 之后等级
      ranks: '',
      // 等级进度
      percentageNum: 70,
      // 解绑微信验证码
      yzmTime: false,
      phoneTitles: '',
      // 账号列表
      accountList: [],
      logoutMessage: '您确认要退出该系统吗？',
      topUsername: '',
      domainUrl: process.env.VUE_APP_DOMAIN + '/iot/'
    }
  },
  watch: {},
  computed: {
  },
  methods: {
    // 获取余额
    async infoAccount () {
      if (this.showBalancePreAmt !== false) {
        return
      }
      try {
        const {
          data: res
        } = await infoAccount({
          token: this.$store.state.token,
          userId: this.$store.state.userID.split('a')[0]
        })
        if (res.msg && res.msg.indexOf('请重新登录') !== -1) {
          this.$router.push('/login/no')
          return
        }
        this.balancePre = res.balance || '0.00'
        this.showBalancePreAmt = true
      } catch (e) {
        console.error(e)
      }
    },
    logout () {
      if (this.$store.state.isAutoAccount === this.$store.state.userName) {
        this.logoutMessage = '此操作将解除当前微信账号的自动登录并退出该系统,您确定执行吗？'
      } else { this.logoutMessage = '您确认要退出该系统吗？' }
      // 确认框
      this.$dialog.confirm({
        title: '温馨提示',
        message: this.logoutMessage
      }).then(() => {
        this.$store.commit('setIsAuto', '')
        this.signOut()
      }).catch(() => {
        // this.$toast('取消退出')
      })
    },
    onSubmit () {
      if (!this.sms) return this.$toast.fail('请填写验证码')
      if (this.sms) {
        Dialog.confirm({
          title: '温馨提示',
          message: '此操作将解除微信账号绑定'
        }).then(async () => {
          // 解绑微信
          const { data: res } = await unBindWeChat({ token: this.$store.state.token, userId: this.$store.state.userID.split('a')[0], code: this.sms })
          if (res.msg && res.msg.indexOf('验证码格式错误') !== -1) return this.$toast.fail('验证码格式错误')
          if (res.code === 0) {
            this.$toast.success('解绑微信成功')
            this.sms = ''
            this.binDingShow = false
            // 退出登录
            this.$store.commit('setIsAuto', '')
            this.signOut()
          }
        }).catch(() => {
          this.$toast('取消解绑微信')
          this.sms = ''
          this.binDingShow = false
        })
      }
    },
    closeDiaLog () {
      this.$refs.hbRef.resetValidation()
      this.sms = ''
    },
    async myInfo () {
      const {
        data: res
      } = await myInfo({
        token: this.$store.state.token,
        userId: this.$store.state.userID.split('a')[0]
      })
      if (res.msg && res.msg.indexOf('请重新登录') !== -1) {
        this.$router.push('/login/no')
        this.$toast.fail('请重新登录')
      }
      this.topUsername = res.agentName
    },
    // 余额
    async profitState () {
      if (this.showProfitAmt !== false) {
        return
      }
      const { data: res } = await profitState({ token: this.$store.state.token, userId: this.$store.state.userID.split('a')[0] })
      this.balance = res.balance
      this.underReview = res.underReview
      this.withdrawn = res.withdrawn
      this.showProfitAmt = true
    },
    // 退出登录
    async signOut () {
      await signOut({ token: this.$store.state.token, userId: this.$store.state.userID.split('a')[0], isAuto: '1' })
      this.$toast.success('退出成功')
      this.$router.push({ name: 'Login' })
      this.$store.commit('setToken', '')
      this.$store.commit('setUserID', '')
      this.$store.commit('setOffEqp', '')
      this.$store.commit('setOverFlowEqp', '')
      this.$store.commit('setSignOut', 'yes')
    },
    changeDownCount () {
      this.$refs.countDown.reset()
      this.yzmTime = false // 关闭倒计时状态
    },
    // 发送验证码
    async getChangeWx () {
      this.$refs.countDown.reset()
      this.yzmTime = true
      const { data: res } = await smsSend({ token: this.$store.state.token, userId: this.$store.state.userID.split('a')[0], type: 1 })
      console.log(res)
    },
    async closeWx () {
      const { data: res } = await getPhoneNumber({ token: this.$store.state.token, userId: this.$store.state.userID.split('a')[0] })
      if (res.msg && res.msg.indexOf('手机号格式错误, 请重新绑定') !== -1) return this.$toast('请前往账户设置中设置手机号')
      this.binDingShow = true
      this.phoneTitles = '将向预留手机 ' + res.mobile + ' 发送验证码'
    }
  },
  beforeCreate () {
    if (!this.$store.state.token) {
      this.$router.push('/login')
      this.$toast.fail('请重新登录')
    }
  },
  created () {
    // this.profit()
    // this.card()
    // this.Rank()
    // this.getTopNum()
    // this.accountList = this.$store.state.accountList ? this.$store.state.accountList : []
    // const agentName = this.$store.state.agentName
    // this.topUsername = (agentName && agentName !== 'undefined') ? this.$store.state.agentName : this.$store.state.userName

    this.myInfo()
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
  .usrBox {
    padding: 0 25px;
    box-sizing: border-box;
    height: 100%;
    /deep/.van-share-sheet__options {
      align-items: center;
      justify-content: center;
    }
    .header {
      height: 380px;
      width: 100%;
      border-radius: 15px;
      background-color: red;
      background: url(../../../assets/home-banner.png) no-repeat center;
      background-size: 100% 385px;
      overflow: hidden;
      padding-top: 30px;
      margin-top: 15px;
      color: #fff;
      .info {
        font-size: 36px;
      }
      .degree {
        padding-top: 35px;
        font-size: 30px;
        /deep/.van-progress__pivot {
          display: none;
        }
      }
      .item {
        padding-top: 5px;
        text-align: center;
        font-size: 28px;
      }
    }
    .van-cell-group {
      margin-top: 15px;
      overflow-y: scroll;
      .van-cell {
        height: 90px;
      }
      .wz {
        color: #AFAFB8;
        text-align: center;
      }
    }
  }
  [class*=van-hairline]::after {
    border: none;
  }
  /deep/.van-dialog {
    height: 450px;
    .van-dialog__header {
      padding-top: 30px;
    }
    .van-dialog__content {
      height: 400px;
      .van-form {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        .van-cell {
          // height: 80px;
          height: 150px;
        }
        .van-cell::after {
          border-color: #d6d8db;
        }
        .btns {
          margin: 0 25px 10px;
        }
      }
      .phoneTitle {
        font-size: 25px;
      }
    }
  }
  .zwf {
    height: 100px;
  }
</style>
